module.exports = __webpack_public_path__ + "static/4-0cc1d0046001c93dc5c32c98ce15cb27.jpg";